import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import isFunction from 'lodash/isFunction'
import Geosuggest from 'react-geosuggest'
import FormControl from './FormControl'
import 'react-geosuggest/module/geosuggest.css'

export default class LocationInput extends FormControl {
  static propTypes = {
    id: PropTypes.string.isRequired,
    extraClass: PropTypes.string,
    label: PropTypes.string,
    labelClass: PropTypes.string,
    placeholder: PropTypes.string,
    helpText: PropTypes.string,
    disabled: PropTypes.bool,
    validationFuncs: PropTypes.array,
    initialValue: PropTypes.object,
    onBlurExternal: PropTypes.func,
    data: PropTypes.object
  }

  static defaultProps = {
    disabled: false,
    validationFuncs: [],
    initialValue: null,
    extraClass: '',
    data: {}
  }
  getValue() {
    return this.state.value
  }

  handleBlur = () => {
    this.validate()

    if (isFunction(this.props.onBlurExternal)) {
      this.props.onBlurExternal()
    }
  }

  render() {
    const { id, label, labelClass, placeholder, disabled, helpText, initialValue, data } = this.props

    const groupClass = classNames({
      'form-group': !this.props.isGroup ? this.props.isGroup : true,
      'has-danger': !this.state.isValid
    })

    const labelClassName = classNames({
      [labelClass]: !!labelClass
    })

    return (
      <fieldset className={groupClass + ' modal-container'} style={{ position: 'relative' }}>
        {label && (
          <label className={labelClassName} htmlFor={id}>
            {label}
          </label>
        )}
        <div className="input-wrapper">
          <Geosuggest
            ref={id}
            id={id}
            initialValue={(initialValue && initialValue.description) || ''}
            placeholder={placeholder}
            disabled={disabled}
            onBlur={this.handleBlur}
            onSuggestSelect={(suggest) => {
              this.handleChange(suggest)
            }}
            onChange={
              this.handleChangeCustom
            }
            types={['(regions)']}
            inputClassName="form-control"
            skipSuggest={function(suggest) {
              return initialValue && initialValue.placeId === suggest['place_id']
            }}
          />
        </div>
        {helpText && <small className="text-muted">{helpText}</small>}
        {this.state.errorMessage && <small className="text-danger">{this.state.errorMessage}</small>}
      </fieldset>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/LocationInput.jsx